import React from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { TextSkeleton } from '@cld/skeleton';
import { CodeSnippetLayout } from '@cld/code-snippet-next';
import { SdkCodeSnippetsLayout } from './SdkCodeSnippetsLayout';

const CodeSkeleton = styled(TextSkeleton)`
  width: 100%;
  min-height: 80px;
`;

const TabsSkeleton = styled(TextSkeleton)`
  width: 20%;
  height: 28px;
  margin-bottom: ${globalTheme.spacing.xs};
`;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  transition: box-shadow 0.2s ease-out;
`;

const ActionSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SdkCodeSnippetsSkeleton = ({ ...rest }) => (
  <Root>
    <SdkCodeSnippetsLayout {...rest}>
      <CodeSnippetLayout
        header={
          <ActionSkeleton>
            <TabsSkeleton isLoading />
            <TabsSkeleton isLoading />
          </ActionSkeleton>
        }
      >
        <CodeSkeleton isLoading />
      </CodeSnippetLayout>
    </SdkCodeSnippetsLayout>
  </Root>
);
